import { html, query, state } from 'lit-element'
import appearanceSettingsStyles from './appearance-settings.styles.scss'
import { t } from '../../directives/translate'
import { ShellElement } from '../../common/shell-element'
import { RadioGroupComponent } from '@getgo/chameleon-web'
import { DEFAULT_THEME, getChameleonTheme, setChameleonTheme } from '../../services/theme'
import { Theme } from '../../services/shell-namespace'

export class GoToAppearanceSettings extends ShellElement {
  static readonly tagName = 'goto-appearance-settings'

  @query('chameleon-radio-group') radioGroup!: RadioGroupComponent
  @state() private selectedTheme: Theme = DEFAULT_THEME
  static get styles() {
    return appearanceSettingsStyles
  }

  constructor() {
    super()
    this.selectedTheme = getChameleonTheme()
  }

  private handleThemeChangeEvent(event: Event) {
    const radioGroup = event.currentTarget as RadioGroupComponent
    this.selectedTheme = radioGroup.value as Theme
    setChameleonTheme(this.selectedTheme)
  }

  render() {
    return html`
      <chameleon-typography tag="h1" class="settings-header" variant="heading-large"
        >${t('Appearance')}</chameleon-typography
      >
      <chameleon-typography class="settings-description" tag="p" variant="body-medium"
        >${t('Change the way things look around here')}</chameleon-typography
      >
      <chameleon-typography
        class="theme-header-description"
        tag="h2"
        variant="heading-medium"
        id="theme-radio-group-heading"
        >${t('Theme')}</chameleon-typography
      >

      <div class="theme-illustration-group">
        <img
          alt=${t('Light Theme')}
          class="theme-illustration light-image"
          src="/assets/theme/Light_Theme_illustration.svg"
        />
        <img
          alt=${t('Dark Theme')}
          class="theme-illustration dark-image"
          src="/assets/theme/Dark_Theme_illustration.svg"
        />
        <img
          alt=${t('System Theme')}
          class="theme-illustration system-image"
          src="/assets/theme/System_Theme_illustration.svg"
        />
      </div>

      <chameleon-radio-group
        @change=${this.handleThemeChangeEvent}
        value=${this.selectedTheme}
        orientation="horizontal"
        class="theme-option-group"
        label-id="theme-radio-group-heading"
      >
        <chameleon-radio-button value="light" class="theme-radio-button light-button"
          >${t('Light')}</chameleon-radio-button
        >
        <chameleon-radio-button value="dark" class="theme-radio-button dark-button"
          >${t('Dark')}</chameleon-radio-button
        >
        <!-- The system option requires a tooltip (see figma). https://jira.ops.expertcity.com/browse/SCORE-2453
         Cannot be added due to -->
        <!-- https://jira.ops.expertcity.com/browse/CHAMELEON-2192 -->
        <!-- <chameleon-tooltip>
          <span slot="tooltip">${t('Automatically match the theme your system uses')}</span> -->
        <chameleon-radio-button value="system" class="theme-radio-button system-button"
          >${t('System')}</chameleon-radio-button
        >
        <!-- </chameleon-tooltip> -->
      </chameleon-radio-group>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    readonly [GoToAppearanceSettings.tagName]: GoToAppearanceSettings
  }
}
